module.exports = __webpack_public_path__ + "img/a1.dc27180d.png";